import React from "react";
import Actions from "./BaseTable/Actions";
import { booleanOptionIconLabels } from "@/constant/GeneralOptions/boolean";

export const columns = () => {
  const booleanOptionLabelsMap = booleanOptionIconLabels();

  return [
    {
      accessorKey: "actions",
      header: "Actions",
      enableResizing: false,
      enableSorting: false,
      cell: ({ row }) => <Actions row={row} />,
    },
    {
      id: "is_featured",
      accessorFn: (row) => booleanOptionLabelsMap[row.is_featured],
      header: "Featured?",
      cell: ({ getValue }) => (
        <div className={"flex justify-center"}>{getValue()}</div>
      ),
    },
    {
      id: "is_public",
      accessorFn: (row) => booleanOptionLabelsMap[row.is_public],
      header: "Public?",
      cell: ({ getValue }) => (
        <div className={"flex justify-center"}>{getValue()}</div>
      ),
    },
    {
      accessorKey: "user",
      header: "Username",
      cell: ({ row }) => <div>{row.original.user?.username ?? "-"} </div>,
    },
    {
      accessorKey: "sport.code",
      header: "Sport ID",
      cell: ({ row }) => <div>{row.original.sport?.code ?? "-"} </div>,
    },
    {
      accessorKey: "created_at",
      header: "Date Posted",
    },
    {
      accessorKey: "picture_category",
      header: "Category",
      cell: ({ row }) => <div>{row.original.picture_category?.name}</div>,
    },
    {
      accessorKey: "comments",
      header: "Comments",
    },
    {
      accessorKey: "react_totals",
      header: "React Total",
    },
    ...[...Array(5)].map((_, index) => ({
      accessorKey: `tag${index + 1}`,
      header: `Tag ${index + 1}`,
      cell: ({ row }) => {
        const tags = row.original.tags || [];
        const tag = tags[index];
        return <div>{tag ? tag.name : "-"}</div>;
      },
    })),
    {
      accessorKey: "total_likes",
      header: "Likes",
      cell: ({ row }) => <div>{row.original.likes?.total_likes || 0}</div>,
    },
    {
      accessorKey: "total_share",
      header: "Shares",
      cell: ({ row }) => <div>{row.original.shares?.total_shares || 0}</div>,
    },
    {
      accessorKey: "total_views",
      header: "Views",
      cell: ({ row }) => <div>{row.original.views?.total_views || 0}</div>,
    },
  ];
};
